export function ResetScroll() {
	window.jQuery?.scrollDepth?.reset?.();
}
